import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useAdminRole } from '@/hooks/useAdminRole';
import { canAccessPath } from '@/hooks/useAdminRole';

interface RoleGuardProps {
  path: string;
  children: React.ReactNode;
}

export default function RoleGuard({ path, children }: RoleGuardProps) {
  const { role } = useAdminRole();
  const navigate = useNavigate();
  const allowed = canAccessPath(path, role);

  useEffect(() => {
    if (!allowed) {
      navigate('/admin', { replace: true });
    }
  }, [allowed, navigate]);

  if (!allowed) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-gray-400">
        <div className="w-16 h-16 flex items-center justify-center mb-4">
          <i className="ri-lock-line text-5xl text-gray-300"></i>
        </div>
        <p className="text-base font-medium text-gray-500">权限不足</p>
        <p className="text-sm mt-1">您没有访问此页面的权限</p>
      </div>
    );
  }

  return <>{children}</>;
}
